// extracted by mini-css-extract-plugin
export default {"selectWarper":"EntityStatistics_selectWarper__+1Fwm","selectDay":"EntityStatistics_selectDay__jzRQ5"};